import { useEffect } from "react";
import { Navigate } from "react-router";
import { resetLocalStorage } from "src/common/resetLocalStorage";
import { resetMixpanel } from "src/mixpanel/Mixpanel";
import { LogoutCred } from "src/redux/slices/credentials";
import { logoutOrganization } from "src/redux/slices/organization";
import { store } from "src/redux/store";

const NoAccessNavigate = ({ to }: { to?: string }) => {
  const accessToken = store.getState()?.credential?.userCred.accessToken;

  useEffect(() => {
    if (!accessToken) {
      resetMixpanel();
      store.dispatch(LogoutCred());
      store.dispatch(logoutOrganization());
      // shutDownIntercomm();
      resetLocalStorage();
      window.location.reload();
    }
  }, [accessToken]);

  if (!accessToken) {
    return null;
  }
  return (
    <>
      <Navigate to={to ? to : "/403"} replace />
    </>
  );
};

export default NoAccessNavigate;
